import React, { useState, useContext } from "react"

import { Grid, Button, Tooltip } from "@material-ui/core"
import PrintIcon from "@material-ui/icons/Print"

import { FormContext } from "Components/Hooks/ContextForm"
import Loader from "Components/UI/Atoms/Loader"
import { interfaces } from "service/interfaces"
import useCustomSnackbar from "Components/UI/Atoms/SnackBar"
import { EditContext } from "Components/Hooks/ContextEdit"
import useStyles from "../../styles"
import { printPDF } from "Helpers"

import TableWith from "./Table"
import InputsWithoutValidate from "Components/UI/Molecules/InputsWithoutValidate"
import SetState from "Components/Hooks/SetState"
import DialogComponent from "Components/UI/Molecules/Modals/DialogComponent"
import CancelConfirmButtons from "Components/UI/Molecules/CancelConfirmButtons"

const AnexaConControl = (props) => {
  const createDismissableSnackbar = useCustomSnackbar()
  const [edit] = useContext(EditContext)
  const classes = useStyles()
  const { formEdit, setFormEdit, setFormApi } = useContext(FormContext)
  const [loading, setLoading] = useState(false)
  const { wafers, habilitar, revisionConfirm } = props
  const [withDominio, setWithDominio] = useState("SI")
  const { state, setClose, setOpen } = SetState()

  async function printWafer() {
    const body = { dominio: withDominio }
    await interfaces.vehicleInterface
      .printWafers(formEdit.vehicle.id, body)
      .then((res) => {
        printPDF(res, 500, 800).print()
      }, setLoading(true))
      .catch((error) => {
        createDismissableSnackbar("Algo salió mal, puede faltar algún dato!", {
          variant: "error",
        })
      })
    setLoading(false)
    setClose()
  }

  const handleChange = (name, value) => {
    setFormEdit((prevFormEdit) => ({
      ...prevFormEdit,
      [name]: value,
    }))

    setFormApi((prevFormApi) => ({
      ...prevFormApi,
      [name]: value,
    }))

    if (name === "dominio") {
      setWithDominio(value)
    }
  }

  async function handleOpen() {
    setLoading(false)
    setOpen()
  }

  const FORM_HOME = (handleChange, edit, formEdit) => {
    return [
      {
        class: "textfield",
        name: "wafersObservation",
        label: "Observación",
        value: formEdit.wafersObservation,
        disabled: !edit,
        sm: 12,
        xs: 12,
        onChange: (e) => {
          handleChange("wafersObservation", e.target.value)
        },
      },
    ]
  }

  return (
    <div className={classes.root}>
      <Grid container>
        <Grid item sm={12}>
          <TableWith wafers={wafers} />
        </Grid>
        <div className={classes.content}>
          <InputsWithoutValidate
            fields={FORM_HOME(handleChange, edit, formEdit)}
            spacing={2}
          />
          <div className={classes.button}>
            <Tooltip
              title={"Debe guardar los cambios antes de presionar este botón"}
              placement="top"
            >
              <Button
                disabled={
                  edit && habilitar === 1
                    ? false
                    : revisionConfirm
                      ? false
                      : true
                }
                onClick={handleOpen}
                variant="contained"
                endIcon={<PrintIcon />}
              >
                Imprimir
              </Button>
            </Tooltip>

            {state.suspense && (
              <DialogComponent
                open={state.open}
                title="¿Agregar dominio?"
                handleclose={setClose}
                widthLarge={"400px"}
                maxHeight
                disableBackdropClick
                disableEscapeKeyDown
                actions={
                  <CancelConfirmButtons
                    onClickCancel={() => setClose()}
                    onClickSubmit={() => printWafer()}
                  />
                }
                children={
                  <InputsWithoutValidate
                    fields={[
                      {
                        class: "autocomplete",
                        name: "dominio",
                        options: [
                          {
                            label: "SI",
                          },
                          {
                            label: "NO",
                          },
                        ],
                        optionLabel: `options["label"]`,
                        optionValue: "label",
                        value: withDominio,
                        sm: 12,
                        xs: 12,
                        onChange: (e) => handleChange("dominio", e.label),
                      },
                    ]}
                    spacing={2}
                  />
                }
              />
            )}
          </div>
        </div>
      </Grid>
      {loading ? <Loader /> : null}
    </div>
  )
}

export default AnexaConControl
